import React from "react";

type IconProps = {
  className?: string;
};

export const ReportIcon = ({ className = "" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M15.3404 2.06887L14.9672 2.0239V2.39981V8.13731V8.17481V8.50814H15.3005H21.5255H21.9302L21.8527 8.11097C21.2249 4.89327 18.5957 2.46107 15.3404 2.06887ZM13.9464 1.5373C13.9464 1.24321 14.2002 1.00814 14.4755 1.00814C18.9458 1.00814 22.6977 4.50301 22.9921 9.00951C22.9901 9.15101 22.9439 9.29268 22.8519 9.41413C22.7531 9.50655 22.6163 9.56647 22.5005 9.56647H14.4755C14.1814 9.56647 13.9464 9.31266 13.9464 9.03731V1.5373Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.666667"
      />
      <path
        d="M20.513 11.5874H12.1505V3.52493C12.1505 3.07493 11.7755 2.69993 11.3255 2.69993C11.213 2.69993 11.1005 2.69993 10.988 2.69993C5.28804 2.66243 0.675537 7.31243 0.675537 13.0124C0.675537 18.7124 5.32554 23.3624 11.0255 23.3624C16.7255 23.3624 21.3755 18.7124 21.3755 13.0124C21.3755 12.7874 21.3755 12.5624 21.338 12.3749C21.338 11.9249 20.963 11.5874 20.513 11.5874ZM11.0255 21.6749C6.22554 21.6749 2.36304 17.8124 2.36304 13.0124C2.36304 8.43743 5.96304 4.64993 10.5005 4.38743V12.4124C10.5005 12.8624 10.8755 13.2749 11.363 13.2749H19.7255C19.5755 17.9249 15.713 21.6749 11.0255 21.6749Z"
        fill="currentColor"
      />
    </svg>
  );
};
